import React from "react";
import { useTranslation } from "react-i18next";
import { renderInputs } from "./cells/inputs";
export const userFormConstructor = (val, t, readOnly, user, data, setVal, addData) => {
  return renderInputs(val, t, readOnly, user, data, setVal, addData);
};
